import '../../components/anchor-link';
import '../../components/quiz-radioboxes-slider';
import '../../components/quiz-questions';
import '../../components/tags';
import '../../components/zooming';
import '../../sections/inner-section';
import '../../sections/first-screen';
import '../../sections/info-tabs';
import '../../sections/info-yard';
import '../../sections/installment-swiper';
import '../../sections/page-navigation';
import '../../sections/banks-navigation';
import '../../sections/property-more';
import '../../sections/progress-gallery';
import '../../sections/progress-years';
import '../../sections/seach-panel-section';
import '../../sections/small-slider';
import '../../sections/stories';
import '../../sections/footer';
import '../../sections/location';
import '../../sections/news';
import '../../sections/reviews';

import {
    audioCollectionInit,
    audioPlayersInit,
    historyStepBack,
    initAccentSliders,
    initAccordions,
    initCallbackPopup,
    initCookie,
    initDiscountForm,
    initFileInput,
    initFlatFrameRequest,
    initForm,
    initFullIframe,
    initFullText,
    initHeader,
    initHorizontalMenu,
    initHybrid,
    initImageTooltip,
    initImgMap,
    initInnerVisual,
    initLayoutLink,
    initMenu,
    initMenuTrigger,
    initMultiSelect,
    initMultiSliders,
    initParametric,
    initPersonsSliders,
    initPopup,
    initPreloader,
    initSalePopups,
    initScrollBy,
    initSearchPanel,
    initShare,
    initSingleSelect,
    initSliderThird,
    initStepSubscribe,
    initTabs,
    initTariffsProgram,
    initThemeBlocks,
    initToggle,
    intersectingEvents,
    lazyLoadElements,
    splitValue,
    yandexMapMini,
    yandexMapPopup
} from 'common/scripts/common';
import Observer from 'common/scripts/observer';

const observer = new Observer();

// Прелоадер
const preloaderElem = document.querySelector('.j-preloader');

if (preloaderElem) {
    initPreloader({
        elem: preloaderElem
    });
}

// Поведение шапки
const headerElement = document.querySelector('.j-header');

if (headerElement) {
    initHeader(headerElement);
}

// Бургер
const menuTriggerElements = Array.from(document.querySelectorAll('.j-menu-trigger'));

if (menuTriggerElements.length) {
    menuTriggerElements.forEach((menuTriggerElement) => {
        initMenuTrigger(menuTriggerElement);
    });
}

// Меню
const menuElement = document.querySelector('.j-menu');

if (menuElement) {
    initMenu(menuElement);
}

// Смена цвета меню
const themeBlocks = Array.from(document.querySelectorAll('.j-theme-block'));

if (themeBlocks.length) {
    initThemeBlocks(themeBlocks);
}

// Ленивая загрузка
const lazyElements = Array.from(document.querySelectorAll('[loading=lazy]'));

if (lazyElements.length) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            lazyLoadElements(lazyElements);
        });
    } else {
        lazyLoadElements(lazyElements);
    }
}

observer.subscribe('lazyLoad:refresh', (container) => {
    const secLazyElements = Array.from(container.querySelectorAll('[loading=lazy]'));

    lazyLoadElements(secLazyElements);
});

// Селекты
const singleSelects = Array.from(document.querySelectorAll('.j-single-select'));

singleSelects.forEach((select) => {
    initSingleSelect(select);
});

const multiSelects = Array.from(document.querySelectorAll('.j-multi-select'));

multiSelects.forEach((select) => {
    initMultiSelect(select);
});

// Карта из изображения
const imgMapElements = Array.from(document.querySelectorAll('.j-img-map'));

imgMapElements.forEach((element) => {
    initImgMap(element);
});

// Карусель 3-го типа
const sliderThirdElements = Array.from(document.querySelectorAll('.j-slider-third'));

sliderThirdElements.forEach((element) => {
    initSliderThird(element);
});

// Табы
const tabs = Array.from(document.querySelectorAll('.j-tabs-wrap'));

tabs.forEach((elem) => {
    initTabs(elem);
});

// Слайдер с множественным наполнением (Тип 2)
const residentialListElements = Array.from(document.querySelectorAll('.j-multi-slider'));

if (residentialListElements.length) {
    residentialListElements.forEach((item) => {
        initMultiSliders(item);
    });
}

// Якоря
const anchors = Array.from(document.querySelectorAll('.j-scrollby'));

if (anchors.length) {
    initScrollBy({anchors});
}

// Слайдер персон (2 связанных слайдера)
const personsSliderElements = Array.from(document.querySelectorAll('.j-slider-persons'));

if (personsSliderElements.length) {
    personsSliderElements.forEach((slider) => {
        initPersonsSliders(slider);
    });
}

// Слайдер с одним большим активным слайдом (Тип 4)
const accentSliderElements = Array.from(document.querySelectorAll('.j-slider-accent'));

if (accentSliderElements.length) {
    accentSliderElements.forEach((slider) => {
        initAccentSliders(slider);
    });
}

const salePopupWrappers = Array.from(document.querySelectorAll('.j-sale-wrapper'));

if (salePopupWrappers.length) {
    salePopupWrappers.forEach((wrapper) => {
        initSalePopups(wrapper);
    });
}

// Формы
const formWrappers = Array.from(document.querySelectorAll('.j-form'));

if (formWrappers.length) {
    formWrappers.forEach((wrapper) => {
        initForm(wrapper);
    });
}

// Попапы через фасад
const popupSelectors = Array.from(document.querySelectorAll('.j-popup'));

if (popupSelectors.length) {
    initPopup(popupSelectors, {removeDelay: 300});

    observer.subscribe('popup:open', (popup) => {
        if (popup.name === 'full') {
            yandexMapPopup(popup.content, popup.currentTarget);
        }
    });
}

// Тарифы (программы доходности)
const tariffsProgram = Array.from(document.querySelectorAll('.j-tariffs-program'));

if (tariffsProgram.length) {
    initTariffsProgram(tariffsProgram);
}

// Отдельный фасад для обратных звонков
const popupFacadeLinks = Array.from(document.querySelectorAll('.j-popup-callback'));

if (popupFacadeLinks.length) {
    // Должен находиться выше подключения параметрического
    initCallbackPopup(popupFacadeLinks);
}

// Отдельный фасад для смена типа формы в кабинете менеджера
const popupFacadeFormtypeLinks = Array.from(document.querySelectorAll('.j-popup-change-formtype'));

if (popupFacadeFormtypeLinks.length) {
    // Должен находиться выше подключения параметрического
    initCallbackPopup(popupFacadeFormtypeLinks);
}

const accordions = Array.from(document.querySelectorAll('.j-accordion'));

if (accordions.length) {
    accordions.forEach((accordion) => {
        initAccordions(accordion);
    });
}

// Открытие ссылки в Iframe
const fullIframe = Array.from(document.querySelectorAll('.j-full-iframe'));

if (fullIframe.length) {
    fullIframe.forEach((target) => {
        initFullIframe(target);
    });
}

const yandexMapMiniElements = Array.from(document.querySelectorAll('.j-map-mini'));

if (yandexMapMiniElements.length) {
    yandexMapMiniElements.forEach((container) => {
        yandexMapMini(container);
    });
}


const horizontalMenuElements = Array.from(document.querySelectorAll('.j-scroll-menu'));

if (horizontalMenuElements.length) {
    horizontalMenuElements.forEach((horizontalMenu) => {
        initHorizontalMenu(horizontalMenu);
    });
}

// Подключение панели параметрического поиска
const searchPanelId = '#search-panel';
const searchPanelWrapper = document.querySelector(searchPanelId);

if (searchPanelWrapper) {
    initSearchPanel({
        id     : searchPanelId,
        wrapper: searchPanelWrapper
    });
}

// Подключение параметрического
const parametricElement = document.querySelector('.j-parametric');

if (parametricElement) {
    initParametric({
        element: parametricElement
    });
}

// Тултипы на изображениях
const imgPins = Array.from(document.querySelectorAll('.j-img-pin'));

if (imgPins.length) {
    imgPins.forEach((pin) => {
        initImageTooltip(pin);
    });
}

// Подключение блока поделиться
const shareWrappers = Array.from(document.querySelectorAll('.j-share'));

if (shareWrappers.length) {
    shareWrappers.forEach((element) => {
        initShare(element);
    });
}

// Непопап про cookies
const cookiePopup = document.querySelector('.j-cookie');

if (cookiePopup) {
    initCookie();
}

// Навешивание целей на форму при появлении ее в области видимости
if (window.location.pathname === '/finishing/') {
    const eventBlock = document.querySelector('#callback-form');

    intersectingEvents(eventBlock);
}

// Разбивает строку сроков окончания строительства
const strings = Array.from(document.querySelectorAll('.j-split-delivery'));

if (strings.length) {
    splitValue(strings);
}

const showFullText = Array.from(document.querySelectorAll('.j-show-full'));

if (showFullText.length) {
    showFullText.forEach((elem) => {
        initFullText(elem);
    });
}

// кнопка "назад"
const back = document.querySelector('.j-back');

if (back) {
    historyStepBack(back);
}

// Встроенный визуальный
const visualIframe = document.querySelector('.j-desktop-visual');

if (visualIframe) {
    initInnerVisual(visualIframe);

    window.addEventListener('resize', () => {
        initInnerVisual(visualIframe);
    });
}

// Заголовок у встроенного визуального
const visualIframeTitle = document.querySelector('.j-desktop-visual-title');

if (visualIframeTitle) {
    initStepSubscribe(visualIframeTitle);
}

// Кнопка для 403 страницы
const reloadButtons = [...document.querySelectorAll('.j-reload-button')];

reloadButtons.forEach((reloadBtn) => {
    reloadBtn.addEventListener('click', () => {
        document.location.reload();
    });
});

const flatFramePage = document.querySelector('.j-flat-card-frame');

if (flatFramePage) {
    initFlatFrameRequest(flatFramePage.dataset.id);
}

const players = Array.from(document.querySelectorAll('.j-audio-player'));

if (players.length) {
    audioPlayersInit(players);
}

const audioCollections = Array.from(document.querySelectorAll('.j-stories-list'));

if (audioCollections.length) {
    audioCollectionInit(audioCollections);
}

// Кат обычный
const cuts = [...document.querySelectorAll('.j-cut')];

if (cuts.length) {
    cuts.forEach((item) => {
        const link = item.querySelector('.j-cut-link');
        const linkSpan = link.querySelector('span');
        const block = item.querySelector('.j-cut-hidden');

        if (link && block) {
            const originalContent = link.innerHTML || 'Читать дальше';

            link.addEventListener('click', (evt) => {
                evt.preventDefault();
                if (block.classList.contains('show')) {
                    block.classList.remove('show');

                    if (linkSpan) {
                        linkSpan.innerHTML = 'Читать дальше';
                    } else {
                        link.innerHTML = originalContent;
                    }
                } else {
                    block.classList.add('show');

                    if (linkSpan) {
                        linkSpan.innerHTML = 'Скрыть';
                    } else {
                        link.innerHTML = 'Скрыть';
                    }
                }
            });
        }
    });
}

// Кат для отзывов
const showMoreContainers = document.querySelectorAll('.j-more');

if (showMoreContainers.length) {
    showMoreContainers.forEach((item) => {
        const link = item.querySelector('.j-more-btn');
        const block = item.querySelector('.j-more-hidden');

        if (link && block) {
            link.addEventListener('click', (evt) => {
                evt.preventDefault();
                if (block.classList.contains('show')) {
                    block.classList.remove('show');
                    link.querySelector('.button__text').innerHTML = 'Показать ещё отзывы';
                } else {
                    block.classList.add('show');
                    link.querySelector('.button__text').innerHTML = 'Скрыть';
                }
            });
        }
    });
}

// Инпуты с файлами в формах
const fileInputs = [...document.querySelectorAll('.j-file-input')];

if (fileInputs.length) {
    initFileInput(fileInputs);
};

// Ссылка на визуальный на макете
const backLinks = [...document.querySelectorAll('.j-layout-link')];

backLinks.forEach((link) => {
    initLayoutLink(link);
});

// Дефолтные туглеры
const toggleElements = Array.from(document.querySelectorAll('.j-toggle-wrapper'));

toggleElements.forEach((toggle) => {
    initToggle(toggle);
});

// Hybrid - события просмотра
initHybrid();


// Форма для webpush - открываем попап при заходе по урлу с якорем
const webpushPopup = document.querySelector('.j-webpush-popup');
const webpushBtn = document.querySelector('.j-webpush-btn');

if (window.location.hash === '#webpush' && webpushBtn && webpushPopup) {
    // эмулируем клик, чтобы открылся попап
    webpushBtn.click();
}

// Форма подписки за скидку
initDiscountForm();

// Mindbox - просмотр
if (window.mindbox) {
    // События просмотра: квартира
    if (window.location.pathname.includes('kvartira-')) {
        const flatFeedId = document.querySelector('[data-feed-flat-id]').dataset.feedFlatId;

        if (flatFeedId) {
            const flatId = flatFeedId ? flatFeedId : parseInt(window.location.pathname.match(/\d+/));

            mindbox('async', {
                operation: 'ViewFlat',
                data     : {
                    viewProduct: {
                        product: {
                            ids: {
                                flatsOnWebSite: flatId
                            }
                        }
                    }
                },
                onSuccess: function () {
                    console.log('mindbox flat');
                },
                onError: function (error) {
                    console.log('mindbox flat - error', error);
                }
            });
        }
    }

    // События просмотра: домен ЖК
    if (window.location.hostname !== 'rbi.ru' && window.location.hostname !== 'www.rbi.ru') {
        if (document.querySelector('[data-feed-object-id]')) {
            const objectFeedId = document.querySelector('[data-feed-object-id]').dataset.feedObjectId;

            if (objectFeedId) {
                const subDomain = objectFeedId ? objectFeedId : window.location.hostname.split('.')[0];

                mindbox('async', {
                    operation: 'ViewComplex',
                    data     : {
                        viewProductCategory: {
                            productCategory: {
                                ids: {
                                    flatsOnWebSite: subDomain
                                }
                            }
                        }
                    },
                    onSuccess: function () {
                        console.log('mindbox complex');
                    },
                    onError: function (error) {
                        console.log('mindbox complex - error', error);
                    }
                });
            }
        }
    }
}

// Mindbox - интеграция с Calltouch
const watchCalltouchForm = (data) => {
    if (!window.mindbox || !data || !data.length) {
        return;
    }

    mindbox('async', {
        operation: 'CalltouchRequest',
        data     : {
            customer: {
                fullName     : '',
                mobilePhone  : data[0].value,
                subscriptions: [{
                    pointOfContact: 'SMS',
                    isSubscribed  : 'true'
                }, {
                    pointOfContact: 'Viber',
                    isSubscribed  : 'true'
                }]
            }
        },
        onSuccess: function() {
            console.log('mindbox calltouch');
        },
        onError: function(error) {
            console.log('mindbox calltouch - error', error);
        }
    });
};

if (window.ct) {
    window.ct('modules', 'widgets', 'subscribeToEvent', [{
        object: 'request',
        action: 'create',

        callback: function(event){
            watchCalltouchForm(event.data.fields);
        }
    }]);
}
